
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hubungi-kami",
      function () {
        return require("private-next-pages/hubungi-kami.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hubungi-kami"])
      });
    }
  